import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { auditService } from "../../services/auditService"

export interface Audit {
  id: number;
  auditName: string;
  auditTypeId: number;
  farmId: number;
  addedBy: string;
  addedDate: string;
  updatedBy: string;
  updatedDate: string;
  inActive: boolean;
  inActiveReason: string;
  inActiveBy: string;
  inActiveDate: string | null;
}

interface AuditState {
  audits: Audit[];
  loading: boolean;
  error: string | null;
}

const initialState: AuditState = {
  audits: [],
  loading: false,
  error: null,
};

export const fetchAudits = createAsyncThunk(
  "audit/fetchAudits",
  async () => {
    const response = await auditService.getAllAudits()
    return response.dataModel
  }
)

const auditSlice = createSlice({
  name: 'audit',
  initialState,
  reducers: {
    setAudits: (state, action: PayloadAction<Audit[] | null | undefined>) => {
      state.audits = Array.isArray(action.payload) ? action.payload : [];
      state.loading = false;
      state.error = null;
    },
    addAudit: (state, action: PayloadAction<Audit>) => {
      state.audits.push(action.payload);
    },
    updateAudit: (state, action: PayloadAction<Audit>) => {
      const index = state.audits.findIndex(audit => audit.id === action.payload.id);
      if (index !== -1) {
        state.audits[index] = action.payload;
      }
    },
    deleteAudit: (state, action: PayloadAction<number>) => {
      state.audits = state.audits.filter(audit => audit.id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAudits.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAudits.fulfilled, (state, action) => {
        state.loading = false
        state.audits = action.payload
      })
      .addCase(fetchAudits.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || "Failed to fetch audits"
      })
  }
});

export const { 
  setAudits, 
  addAudit, 
  updateAudit, 
  deleteAudit, 
  setLoading, 
  setError 
} = auditSlice.actions;

export default auditSlice.reducer; 